module.exports = __webpack_public_path__ + "68d43cde445c188281634b217a9c7b63.fbx";